import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class VentaService {

  constructor(private http: HttpClient, private config: ConfigService) { }

  getMetodoPago(token: String) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Venta/MetodoPago";
    return this.http.get(url, requestOptions);
  }

  getChannelSales(token: String) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Venta/CanalVenta";
    return this.http.get(url, requestOptions);

  }

  getCommercialPolicy(token: String) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Venta/PoliticaComercial";
    return this.http.get(url, requestOptions);

  }

  getVendedorTienda(token: String, idTienda: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Venta/Vendedor/" + idTienda;
    return this.http.get(url, requestOptions);
  }

  getRecibo(token: String = "", idVenta: number) {
    if (token != "") {
      const requestOptions = new Object({
        headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      });
      const url = this.config.urlService + "api/Venta/Recibo/" + idVenta;
      return this.http.get(url,requestOptions);
    }
    else{
      const url = this.config.urlService + "api/Venta/Recibo/" + idVenta;
      return this.http.get(url);
    }

    
  }

  getDetalleVenta(token: String, idVenta: number, idProveedor: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      'Content-Type': 'text/plain; charset=utf-8'
    });
    const url = this.config.urlService + "api/Venta/DetalleVenta/" + idVenta.toString() + "/" + idProveedor.toString();
    return this.http.get(url, requestOptions);
  }

  getNotaCredito(token: String, idVenta: number, idProveedor: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      'Content-Type': 'text/plain; charset=utf-8'
    });
    const url = this.config.urlService + "api/Venta/NotaCredito/" + idVenta.toString() + "/" + idProveedor.toString();
    return this.http.get(url, requestOptions);
  }

  getDetalleNotaCredito(token: String, idVenta: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      'Content-Type': 'text/plain; charset=utf-8'
    });
    const url = this.config.urlService + "api/Venta/DetalleNotaCredito/" + idVenta.toString();
    return this.http.get(url, requestOptions);
  }

  // 1: obligatorio (automática), 
  // 2: Opcional (decisión del personal de caja)
  // 3: inactivo (no se pregunta)
  setVenta(token: String, data: any, optionFE: number, idCotizacion?: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      'Content-Type': 'text/plain; charset=utf-8'
    });
    const url = this.config.urlService + "api/Venta/set/" + optionFE + "/" + (idCotizacion ?? 0);
    return this.http.post(url, data, requestOptions);
  }

  // proceso de registro sobre la tabla IntegracionElectronico
  setInsertFE(token: String, data: any, optionFE: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      'Content-Type': 'text/plain; charset=utf-8'
    });
    const url = this.config.urlService + "api/Venta/setFE/" + optionFE;
    return this.http.post(url, data, requestOptions);
  }

  setNotaCredito(token: String, data: any, idVenta: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      'Content-Type': 'text/plain; charset=utf-8'
    });
    const url = this.config.urlService + "api/Venta/NotaCredito/" + idVenta;
    return this.http.post(url, data, requestOptions);
  }

  setCancelar(token: String, data: any) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      'Content-Type': 'text/plain; charset=utf-8'
    });
    const url = this.config.urlService + "api/Venta/Cancelar";
    return this.http.post(url, data, requestOptions);
  }

  setVentaCliente(token: string, data: any, idVenta: number, idNotificacion: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      'Content-Type': 'text/plain; charset=utf-8'
    });
    const url = this.config.urlService + "api/Venta/Cliente/" + idVenta.toString() + "/" + idNotificacion.toString();
    return this.http.post(url, data, requestOptions);
  }

  setReasignacionVendedor(token: string, data: any, idVenta: number, idSales: number, idTienda: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      'Content-Type': 'text/plain; charset=utf-8'
    });
    const url = this.config.urlService + "api/Venta/ReasignacionVentas/" + idVenta.toString() + "/" + idSales.toString() + "/" + (idTienda).toString();
    return this.http.post(url, data, requestOptions);
  }

  sendNotificacion(token: string, data: any, idVenta: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      'Content-Type': 'text/plain; charset=utf-8'
    });
    const url = this.config.urlService + "api/Venta/Notificacion/" + idVenta.toString();
    return this.http.post(url, data, requestOptions);
  }

  //*************************** import infotmation from integration  *****************************************
  getHeaderIntegration(token: string, idVenta: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      'Content-Type': 'text/plain; charset=utf-8'
    });
    const url = this.config.urlService + "api/Venta/HeaderIntegration/" + idVenta.toString();
    return this.http.get(url, requestOptions);
  }


  getDetailHeaderIntegration(token: string, idVenta: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      'Content-Type': 'text/plain; charset=utf-8'
    });
    const url = this.config.urlService + "api/Venta/DetailHeaderIntegration/" + idVenta.toString();
    return this.http.get(url, requestOptions);
  }


  getDetailPayments(token: string, idVenta: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      'Content-Type': 'text/plain; charset=utf-8'
    });
    const url = this.config.urlService + "api/Venta/DetailPayments/" + idVenta.toString();
    return this.http.get(url, requestOptions);
  }
}
